import React from 'react'

import { Box, Container, Grid, Typography, Button } from '@mui/material'
import { ArrowBack, RocketLaunch } from '@mui/icons-material'
import { Gauge, gaugeClasses } from '@mui/x-charts'

import Card from 'atoms/Card'

function TSPGoals({ openTest, goBack }) {
  return (
    <Card>
      <Box px={3} py={2} display="flex" justifyContent="space-between">
        <Grid container>
          <Box
            item
            sx={{
              display: 'flex',
              width: '100%',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignContent: 'flex-start',
              alignItems: 'center',

              borderRadius: '75px 16px 16px 75px',
            }}
          >
            <Box sx={{ maxWidth: 100 }}>
              <Gauge
                width={100}
                height={100}
                cornerRadius={'50%'}
                value={54}
                innerRadius={'90%'}
                outerRadius={'125%'}
                //need % sign to be smaller
                text={({ value }) => `${value}%`}
                sx={() => ({
                  alignItems: 'flex-start',
                  fontWeight: 600,
                  fontSize: 24,
                  [`& svg`]: {
                    borderRadius: '50%',
                    width: '100px',
                    height: '100px',
                  },
                  [`& .${gaugeClasses.valueArc}`]: { fill: '#2370ED' },
                })}
              />
            </Box>
            <Box px={2} maxWidth={350}>
              <Box display={'flex'} flexDirection={'row'}>
                <Typography variant="body1Medium" color={'#262627'}>
                  $2,000,000 TSP Progress
                </Typography>
              </Box>
              <Box>
                <Typography variant="body2" color={'#495057'}>
                  You have saved $1,080,000 (or 54% of your goal) so far
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Box>
    </Card>
  )
}

export default TSPGoals
